<template>
	<v-select
		v-model="select"
		label="Selecionar Etapa do Evento"
		:items="selectItems"
		item-text="text"
		item-value="value"
		solo-inverted
		dense
		hide-details
		prepend-icon="mdi-calendar-clock"
		@change="setSelectEventStage"
	>
	</v-select>
</template>
<script>
	export default {
		name: "components-common-filters-select-event-stage",
		data: () => ({
			select: "",
		}),
		computed: {
			selectItems() {
				return [
					{ text: this.$t("preMatch"), value: "prematch" },
					{ text: this.$t("matchDay"), value: "daymatch" },
					{ text: this.$t("prematchAndMatchday"), value: "both" },
					{ text: this.$t("live"), value: "live" },
				];
			},
			eventStage() {
				return this.$store.state.filters.selectEventStage.value;
			},
		},
		mounted() {
			this.select = this.eventStage;
		},
		methods: {
			setSelectEventStage(value) {
				this.$store.commit("setSelectEventStage", value);
			},
		},
	};
</script>
